import { ContentCheck } from '@fs/zion-icon'
import { Button, DialogOverlay, DialogOverlayActions, useOverlay, Paragraph, IconButton } from '@fs/zion-ui'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { SCREENING_STATE, SCREENING_TAG } from '../util/artifactsConstants'
import { updateArtifact } from '../../../services/artifactService'
import useNotifications from '../../../hooks/useNotifications'

export default function UnrestrictSelectedActionButton({ checkedArtifacts, setCheckedArtifacts, refetch }) {
  const { t } = useTranslation()
  const { error, ok } = useNotifications()
  const unrestrictSelectedArtifactsOverlay = useOverlay()

  const unrestrictSelectedOnSubmit = async () => {
    unrestrictSelectedArtifactsOverlay.close()
    const unrestrictArtifactResponses = await Promise.allSettled(
      checkedArtifacts.map((artifactId) => {
        return updateArtifact({
          id: artifactId,
          ID: artifactId,
          screeningState: SCREENING_STATE.APPROVED,
          screeningTag: SCREENING_TAG.NOT_SET,
        })
      })
    )
    const failedToUnrestrictArtifactIds = []
    unrestrictArtifactResponses.forEach((response) => {
      if (response.status === 'rejected') {
        const payload = JSON.parse(response.reason.config.data)
        failedToUnrestrictArtifactIds.push(payload.id)
      }
    })
    refetch()
    if (unrestrictArtifactResponses.length === failedToUnrestrictArtifactIds.length) {
      error(t('artifacts.unrestrictSelectedAllFailed', 'Error unrestricting selected artifacts'))
    } else if (failedToUnrestrictArtifactIds.length > 0) {
      error(
        t(
          'artifacts.unrestrictSelectedSomeFailed',
          'Error unrestricting the following artifact IDs: { failedToUnrestrictArtifactIds }',
          {
            failedToUnrestrictArtifactIds: JSON.stringify(failedToUnrestrictArtifactIds),
          }
        )
      )
    } else {
      ok(t('artifacts.unrestrictSelectedSuccess', 'Unrestricted selected artifacts'))
    }
    setCheckedArtifacts((prev) => prev.filter((artifactId) => failedToUnrestrictArtifactIds.includes(artifactId)))
  }

  return (
    <>
      <IconButton
        title={t('action.unrestrictSelected', 'Unrestrict Selected')}
        onClick={unrestrictSelectedArtifactsOverlay.handleClick}
        Icon={ContentCheck}
        color="green"
        emphasis="high"
      />
      <DialogOverlay
        title={t('action.unrestrictSelected', 'Unrestrict Selected')}
        {...unrestrictSelectedArtifactsOverlay}
      >
        <Paragraph size="sm">
          {checkedArtifacts.length > 1
            ? t('artifacts.unrestrictMulipleConfirmation', 'Are you sure you want to unrestrict these artifacts?')
            : t('artifacts.unrestrictConfirmation', 'Are you sure you want to unrestrict this artifact?')}
        </Paragraph>
        <DialogOverlayActions>
          <Button onClick={unrestrictSelectedOnSubmit} emphasis="high">
            {t('action.submit', 'Submit')}
          </Button>
          <Button onClick={unrestrictSelectedArtifactsOverlay.close}>{t('action.cancel', 'Cancel')}</Button>
        </DialogOverlayActions>
      </DialogOverlay>
    </>
  )
}
